"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.completeTaskAndCommentAndSetVar = exports.completeTaskAndCommentAndAdopt = exports.completeTaskAndComment = void 0;
var _api = _interopRequireDefault(require("@/libs/api.request"));
/**
 * 完成任务并且添加批注信息+通过状态+批注状态+流程变量
 * @param taskId
 * @param comment
 * @param adopt
 * @returns {*}
 */
var completeTaskAndCommentAndSetVar = exports.completeTaskAndCommentAndSetVar = function completeTaskAndCommentAndSetVar(taskId, comment, adopt) {
  return _api.default.request({
    url: '/flow/task/completeTaskAndCommentAndSetVar',
    method: 'post',
    params: {
      taskId: taskId,
      comment: comment,
      adopt: adopt
    }
  });
};

/**
 * 完成任务并且添加批注信息+通过状态+批注状态
 * @param taskId
 * @param comment
 * @param adopt
 * @returns {*}
 */
var completeTaskAndCommentAndAdopt = exports.completeTaskAndCommentAndAdopt = function completeTaskAndCommentAndAdopt(taskId, comment, adopt) {
  return _api.default.request({
    url: '/flow/task/completeTaskAndCommentAndAdopt',
    method: 'post',
    params: {
      taskId: taskId,
      comment: comment,
      adopt: adopt
    }
  });
};

/**
 * 完成任务并且添加批注信息+通过状态
 * @param taskId
 * @param comment
 * @returns {*}
 */
var completeTaskAndComment = exports.completeTaskAndComment = function completeTaskAndComment(taskId, comment) {
  return _api.default.request({
    url: '/flow/task/completeTaskAndComment',
    method: 'post',
    params: {
      taskId: taskId,
      comment: comment
    }
  });
};